import api from '../../api'

export default {
    async initialize({ dispatch }) {
        await dispatch('getParentData')
    },
    async getParentData({ commit }) {
        try {
            var data = await api.base.fetchParentData()
            commit('SET_STATES', data.states)
            commit('SET_GENDERS', data.genders)
            commit('SET_DISEASES', data.diseases)
            commit('SET_INDIGENOUS_OPTIONS', data.indigenousOptions)
            commit('SET_URGENCIES', data.urgencies)
            commit('SET_REQUEST_STATUSES', data.requestStatuses)
            commit('SET_DISCIPLINES', data.disciplines)
            commit('SET_SERVICE_TASK_STATUSES', data.serviceTaskStatuses)
            commit('SET_COST_CENTRES', data.costCentres)
            commit('SET_TEAMS', data.teams)
            commit('SET_TASK_TYPES', data.taskTypes)
            commit('SET_APPROVAL_CRITERIA', data.approvalCriteria)
            commit('SET_ROLES', data.roles)
        } catch (error) {
            // alert('Error connecting to server, please try refreshing your browser.')
        }
    },
    async setPractices({ commit }) {
        try {
            var response = await api.admin.fetchPractices({})
            commit('SET_PRACTICES', response.data)
        } catch (error) {
            commit('SET_PRACTICES', {})
        }
    }
}
